const answers = [
  'ábaco',
  'abajo',
  'abecé',
  'abeja',
  'abeto',
  'abono',
  'abril',
  'abrir',
  'abuso',
  'acabe',
  'acabo',
  'ácaro',
  'acaso',
  'acato',
  'acera',
  'acero',
  'ácido',
  'acilo',
  'acodo',
  'acose',
  'acoso',
  'actor',
  'acuse',
  'adiós',
  'adoba',
  'adobe',
  'adobo',
  'adoro',
  'adula',
  'aéreo',
  'afear',
  'áfono',
  'afore',
  'aforo',
  'ágape',
  'ágata',
  'agave',
  'ágora',
  'agote',
  'agrio',
  'aguar',
  'agudo',
  'aguja',
  'aguzo',
  'ahogo',
  'ahora',
  'airar',
  'aireo',
  'ajeno',
  'ajete',
  'álabe',
  'álamo',
  'alano',
  'albar',
  'albor',
  'álbum',
  'aldea',
  'alear',
  'aleja',
  'alelí',
  'alelo',
  'alero',
  'aleta',
  'alfar',
  'alfil',
  'algún',
  'aliar',
  'alijo',
  'aliño',
  'aloja',
  'altar',
  'aluda',
  'aludo',
  'álveo',
  'alzar',
  'amado',
  'amago',
  'amaño',
  'amaro',
  'ámbar',
  'ambos',
  'ameba',
  'ameno',
  'amida',
  'amiga',
  'amigo',
  'amina',
  'amino',
  'ancha',
  'ancho',
  'ancla',
  'andar',
  'andén',
  'anejo',
  'anexo',
  'ángel',
  'anglo',
  'ánima',
  'anime',
  'anión',
  'ánodo',
  'ansia',
  'antes',
  'antro',
  'anual',
  'ánulo',
  'añada',
  'añejo',
  'añojo',
  'añoso',
  'aojar',
  'aorta',
  'aovar',
  'apaño',
  'apear',
  'apego',
  'apena',
  'apero',
  'ápice',
  'apodo',
  'ápodo',
  'apoyo',
  'apure',
  'apuro',
  'aquel',
  'aqueo',
  'árabe',
  'arada',
  'arado',
  'araña',
  'araño',
  'árbol',
  'arcén',
  'arcón',
  'arder',
  'ardid',
  'ardor',
  'arduo',
  'arena',
  'argón',
  'argot',
  'árido',
  'aries',
  'armar',
  'arnés',
  'aroma',
  'aromo',
  'arpía',
  'arpón',
  'arras',
  'arreo',
  'arroz',
  'asado',
  'ascua',
  'asear',
  'asilo',
  'asomo',
  'astro',
  'astur',
  'atado',
  'atajo',
  'ataúd',
  'ático',
  'atino',
  'átomo',
  'atona',
  'átono',
  'atoro',
  'atrás',
  'atril',
  'atrio',
  'atroz',
  'audaz',
  'audio',
  'augur',
  'aunar',
  'aupar',
  'áureo',
  'autor',
  'avaro',
  'avena',
  'aveza',
  'aviar',
  'ávido',
  'avión',
  'aviso',
  'axial',
  'axila',
  'ayuda',
  'ayuno',
  'azada',
  'azote',
  'babia',
  'babor',
  'bache',
  'bacín',
  'badén',
  'badil',
  'bafle',
  'bagre',
  'bahía',
  'baila',
  'baile',
  'bajar',
  'bajel',
  'bajío',
  'bajón',
  'balar',
  'balda',
  'balde',
  'balín',
  'balón',
  'balsa',
  'bamba',
  'bambú',
  'banal',
  'banca',
  'banco',
  'banda',
  'bando',
  'banjo',
  'bañar',
  'barba',
  'barca',
  'barco',
  'bardo',
  'baria',
  'bario',
  'barón',
  'barra',
  'barro',
  'basal',
  'basar',
  'basta',
  'baste',
  'basto',
  'bateo',
  'batín',
  'batir',
  'bazar',
  'beata',
  'beato',
  'beber',
  'becar',
  'bedel',
  'beige',
  'belén',
  'belga',
  'belio',
  'bello',
  'bemol',
  'beque',
  'besar',
  'betún',
  'bicho',
  'bidón',
  'biela',
  'bilis',
  'bingo',
  'bioma',
  'birra',
  'bisel',
  'bizco',
  'blues',
  'blusa',
  'bocha',
  'boina',
  'bolín',
  'bollo',
  'bolsa',
  'bolso',
  'bomba',
  'bombo',
  'bonus',
  'borda',
  'borde',
  'bordo',
  'borla',
  'borne',
  'borro',
  'bosta',
  'botar',
  'botín',
  'botón',
  'boxeo',
  'bozal',
  'braco',
  'braga',
  'brama',
  'brasa',
  'brava',
  'bravo',
  'braza',
  'brazo',
  'brega',
  'brete',
  'breva',
  'breve',
  'brezo',
  'brial',
  'bríos',
  'brisa',
  'broca',
  'broma',
  'bromo',
  'brota',
  'brote',
  'bruja',
  'brujo',
  'bruma',
  'bruta',
  'bruto',
  'bubón',
  'bucal',
  'buceo',
  'buche',
  'bucle',
  'budín',
  'buena',
  'bueno',
  'bufar',
  'bufón',
  'bujía',
  'bulbo',
  'bulla',
  'bulto',
  'buque',
  'buqué',
  'burda',
  'burdo',
  'burgo',
  'burla',
  'burra',
  'burro',
  'busca',
  'busco',
  'busto',
  'buzón',
  'buzos',
  'cabal',
  'caber',
  'cable',
  'cabra',
  'cacao',
  'cacho',
  'cafre',
  'caída',
  'caído',
  'cajón',
  'calar',
  'calca',
  'calés',
  'cáliz',
  'calle',
  'callo',
  'calma',
  'calmo',
  'calor',
  'calva',
  'calvo',
  'calza',
  'calzo',
  'campo',
  'canal',
  'canje',
  'canoa',
  'canso',
  'canta',
  'cante',
  'canto',
  'cañal',
  'cañón',
  'caoba',
  'capar',
  'capaz',
  'capón',
  'caqui',
  'cardo',
  'careo',
  'carga',
  'cargo',
  'cariz',
  'carné',
  'carne',
  'carpa',
  'carpo',
  'carro',
  'carta',
  'casar',
  'casco',
  'casón',
  'caspa',
  'casta',
  'casto',
  'catar',
  'catre',
  'cauce',
  'causa',
  'cavar',
  'cazar',
  'cebar',
  'cebra',
  'ceceo',
  'ceder',
  'cedro',
  'cegar',
  'celda',
  'celta',
  'cenar',
  'cenit',
  'censo',
  'ceñir',
  'cerca',
  'cerco',
  'cerda',
  'cerdo',
  'cerro',
  'cesar',
  'césar',
  'cesio',
  'cesta',
  'cesto',
  'cetro',
  'ceutí',
  'chafa',
  'chalé',
  'chapa',
  'chata',
  'chato',
  'checo',
  'chepa',
  'chica',
  'chico',
  'chile',
  'china',
  'chino',
  'chita',
  'chivo',
  'chopo',
  'chota',
  'choza',
  'chulo',
  'chute',
  'chuzo',
  'ciclo',
  'cidra',
  'cidro',
  'ciego',
  'cielo',
  'cieno',
  'cifra',
  'cinco',
  'cinta',
  'circe',
  'circo',
  'cisma',
  'cisne',
  'citar',
  'civil',
  'clara',
  'claro',
  'clase',
  'clava',
  'clave',
  'clavo',
  'clero',
  'clima',
  'cloro',
  'cobra',
  'cobre',
  'cobro',
  'cocer',
  'coche',
  'codal',
  'códex',
  'cofre',
  'coger',
  'coima',
  'coito',
  'cojín',
  'colar',
  'colín',
  'colmo',
  'colon',
  'color',
  'comba',
  'comer',
  'cómic',
  'común',
  'conde',
  'conga',
  'conta',
  'copar',
  'copia',
  'copla',
  'copón',
  'copto',
  'coque',
  'coral',
  'corán',
  'corea',
  'corra',
  'corro',
  'corsé',
  'corso',
  'corta',
  'corte',
  'corto',
  'corva',
  'corvo',
  'coser',
  'costa',
  'coste',
  'costo',
  'coxal',
  'coxis',
  'crack',
  'craso',
  'crear',
  'credo',
  'creer',
  'crema',
  'creta',
  'criar',
  'criba',
  'cribo',
  'croar',
  'cromo',
  'crono',
  'cruce',
  'crudo',
  'cruel',
  'cruza',
  'cubil',
  'cuero',
  'cueva',
  'culpa',
  'culto',
  'cuota',
  'cupón',
  'curar',
  'curdo',
  'curia',
  'curio',
  'curro',
  'curry',
  'cursi',
  'curso',
  'curva',
  'curvo',
  'cutis',
  'cutre',
  'dador',
  'dalia',
  'dance',
  'danés',
  'danza',
  'dañar',
  'dardo',
  'datar',
  'dátil',
  'deber',
  'débil',
  'debut',
  'decir',
  'dedal',
  'dejar',
  'delta',
  'demás',
  'denso',
  'dente',
  'derbi',
  'desde',
  'deseo',
  'deuda',
  'deudo',
  'diana',
  'dicha',
  'dicho',
  'dieta',
  'digno',
  'dinar',
  'diodo',
  'dique',
  'disco',
  'diván',
  'doble',
  'doblo',
  'dócil',
  'docto',
  'dogma',
  'dólar',
  'doler',
  'dolor',
  'domar',
  'donar',
  'donde',
  'dónde',
  'dopar',
  'dorar',
  'dorio',
  'dosel',
  'dosis',
  'dotar',
  'draga',
  'drama',
  'droga',
  'ducal',
  'ducha',
  'ducho',
  'dudar',
  'duela',
  'duelo',
  'dueña',
  'dueño',
  'dueto',
  'dulce',
  'dupla',
  'duque',
  'durar',
  'ébano',
  'ebrio',
  'echar',
  'edema',
  'ejido',
  'élite',
  'ellos',
  'enano',
  'encía',
  'enema',
  'enero',
  'enojo',
  'entre',
  'entro',
  'envés',
  'envío',
  'épica',
  'épico',
  'época',
  'equis',
  'erbio',
  'erial',
  'erizo',
  'errar',
  'error',
  'espía',
  'esquí',
  'estar',
  'estío',
  'estos',
  'etano',
  'etapa',
  'ética',
  'ético',
  'etilo',
  'éxito',
  'éxodo',
  'extra',
  'fácil',
  'faena',
  'fagot',
  'fajín',
  'fajón',
  'falaz',
  'falda',
  'falla',
  'fallo',
  'falsa',
  'falso',
  'falta',
  'falte',
  'falto',
  'fango',
  'fardo',
  'fario',
  'farol',
  'farra',
  'farsa',
  'fatal',
  'fatuo',
  'fauna',
  'fauno',
  'favor',
  'fecal',
  'fecha',
  'fecho',
  'feliz',
  'felón',
  'felpa',
  'fémur',
  'fénix',
  'fenol',
  'feria',
  'feroz',
  'ferry',
  'fetal',
  'feudo',
  'fiado',
  'fibra',
  'ficha',
  'ficus',
  'fideo',
  'fiera',
  'fiero',
  'fijar',
  'filia',
  'filme',
  'filón',
  'final',
  'finar',
  'finca',
  'finés',
  'finta',
  'firma',
  'firme',
  'fisco',
  'flaco',
  'flato',
  'fleco',
  'flema',
  'flexo',
  'flojo',
  'flora',
  'flota',
  'flote',
  'fluir',
  'flujo',
  'flúor',
  'focal',
  'fogón',
  'folio',
  'fondo',
  'foral',
  'forja',
  'forma',
  'forro',
  'forte',
  'fósil',
  'fotón',
  'frase',
  'freír',
  'freno',
  'fresa',
  'freso',
  'friso',
  'frito',
  'fruta',
  'fruto',
  'fuego',
  'fuera',
  'fuero',
  'fugaz',
  'fular',
  'fumar',
  'funda',
  'fundo',
  'furia',
  'furor',
  'fusil',
  'fusta',
  'fuste',
  'futón',
  'gabán',
  'gacha',
  'gacho',
  'gafar',
  'gaita',
  'galán',
  'galés',
  'galga',
  'galgo',
  'galio',
  'gallo',
  'galón',
  'gamba',
  'gamma',
  'ganar',
  'ganga',
  'ganso',
  'gañán',
  'garbo',
  'garra',
  'garza',
  'garzo',
  'gasto',
  'gateo',
  'gemir',
  'genio',
  'gente',
  'geoda',
  'gesta',
  'gesto',
  'girar',
  'globo',
  'glosa',
  'glose',
  'gnomo',
  'gofre',
  'goles',
  'golfa',
  'golfo',
  'golpe',
  'gorda',
  'gordo',
  'gorra',
  'gorro',
  'goteo',
  'gozar',
  'gozne',
  'grada',
  'grado',
  'grafo',
  'grajo',
  'gramo',
  'grana',
  'grano',
  'grapa',
  'grasa',
  'graso',
  'grata',
  'grato',
  'grava',
  'grave',
  'greba',
  'greca',
  'greco',
  'greda',
  'greña',
  'grial',
  'grifo',
  'grima',
  'gripe',
  'gripo',
  'grisú',
  'grita',
  'grito',
  'grumo',
  'grupo',
  'gruta',
  'guano',
  'guapo',
  'gueto',
  'guiar',
  'güino',
  'guiño',
  'guisa',
  'guiso',
  'gulag',
  'gusto',
  'haber',
  'hábil',
  'habla',
  'hacer',
  'hacha',
  'hache',
  'hacia',
  'hampa',
  'harén',
  'harpa',
  'harto',
  'hasta',
  'hebra',
  'hecha',
  'hecho',
  'heder',
  'hedor',
  'helar',
  'helio',
  'henar',
  'henil',
  'herir',
  'héroe',
  'hiato',
  'hidra',
  'hielo',
  'hiena',
  'hiera',
  'hilar',
  'himen',
  'himno',
  'hinco',
  'hindi',
  'hindú',
  'hipar',
  'hogar',
  'honda',
  'hondo',
  'hongo',
  'honor',
  'honra',
  'horca',
  'horda',
  'horma',
  'horno',
  'hosco',
  'hotel',
  'hucha',
  'hueca',
  'hueco',
  'hueso',
  'hueva',
  'huevo',
  'huida',
  'huido',
  'huilo',
  'huira',
  'hulla',
  'humor',
  'humus',
  'hurón',
  'hurto',
  'húsar',
  'ibero',
  'icono',
  'ictus',
  'ideal',
  'idear',
  'ídolo',
  'ígneo',
  'igual',
  'ileso',
  'iluso',
  'impar',
  'impía',
  'impío',
  'inane',
  'india',
  'indio',
  'ingle',
  'iraní',
  'islam',
  'istmo',
  'ítalo',
  'itrio',
  'izado',
  'jabón',
  'jadeo',
  'jalar',
  'jalea',
  'jaleo',
  'jamás',
  'jamón',
  'jaque',
  'jarra',
  'jarro',
  'jaula',
  'jején',
  'jeque',
  'jerbo',
  'jerez',
  'jerga',
  'jirón',
  'jonio',
  'joven',
  'jubón',
  'judía',
  'judío',
  'juego',
  'jugar',
  'julio',
  'junco',
  'junio',
  'junta',
  'junto',
  'jurar',
  'justa',
  'justo',
  'kappa',
  'karma',
  'kayak',
  'kebab',
  'koala',
  'koiné',
  'kurdo',
  'labia',
  'labio',
  'labor',
  'labra',
  'lacar',
  'lacio',
  'lacón',
  'lacra',
  'ladeo',
  'ladra',
  'laico',
  'lamer',
  'lamia',
  'lanar',
  'lance',
  'landa',
  'lanza',
  'lápiz',
  'lapón',
  'lapso',
  'larga',
  'largo',
  'larva',
  'láser',
  'látex',
  'latín',
  'latir',
  'latón',
  'lauro',
  'lavar',
  'laxar',
  'lazar',
  'leche',
  'lecho',
  'legal',
  'legar',
  'legua',
  'leída',
  'leído',
  'lejía',
  'lejos',
  'lémur',
  'lente',
  'lento',
  'lepra',
  'lerda',
  'lerdo',
  'letal',
  'letón',
  'letra',
  'liana',
  'libio',
  'libra',
  'libre',
  'libro',
  'liceo',
  'licor',
  'licra',
  'líder',
  'lidia',
  'lidio',
  'ligar',
  'ligur',
  'lijar',
  'limar',
  'limbo',
  'limón',
  'linar',
  'lince',
  'lindo',
  'línea',
  'linfa',
  'lioso',
  'liria',
  'lirio',
  'lirón',
  'lista',
  'listo',
  'litio',
  'litro',
  'llaga',
  'llama',
  'llana',
  'llano',
  'llave',
  'llega',
  'llena',
  'lleno',
  'lleva',
  'lleve',
  'lloro',
  'local',
  'logos',
  'logro',
  'lonja',
  'lorza',
  'lucha',
  'luche',
  'lucir',
  'lucro',
  'luego',
  'lugar',
  'lumen',
  'lunar',
  'lunes',
  'luxar',
  'lycra',
  'macho',
  'macro',
  'madre',
  'maese',
  'mafia',
  'magma',
  'magno',
  'magra',
  'magro',
  'mahón',
  'majal',
  'majar',
  'malar',
  'malla',
  'malta',
  'malva',
  'mamar',
  'mamba',
  'mambo',
  'mamón',
  'mamut',
  'manar',
  'manco',
  'mando',
  'manga',
  'mango',
  'manía',
  'manso',
  'manta',
  'manto',
  'maorí',
  'marca',
  'marco',
  'marea',
  'mareo',
  'marra',
  'marte',
  'marzo',
  'masái',
  'masía',
  'masón',
  'matar',
  'matiz',
  'matón',
  'maula',
  'mayor',
  'meada',
  'meado',
  'mecer',
  'mecha',
  'media',
  'medio',
  'medir',
  'medra',
  'meigo',
  'mejor',
  'melar',
  'mella',
  'melón',
  'memez',
  'menor',
  'menos',
  'menta',
  'mente',
  'merma',
  'mesar',
  'mesón',
  'metal',
  'meter',
  'metro',
  'micra',
  'miedo',
  'migar',
  'migra',
  'milla',
  'mimar',
  'minar',
  'minué',
  'mioma',
  'miope',
  'mirar',
  'mirlo',
  'mirón',
  'mirra',
  'mismo',
  'mitad',
  'mitón',
  'mitra',
  'miura',
  'mixta',
  'mixto',
  'mocho',
  'modal',
  'mohín',
  'mojar',
  'mojón',
  'molar',
  'molde',
  'moler',
  'molla',
  'momia',
  'monje',
  'monta',
  'monte',
  'monto',
  'moral',
  'morar',
  'morbo',
  'morir',
  'morro',
  'morsa',
  'morse',
  'mosca',
  'mosto',
  'motel',
  'motín',
  'motor',
  'móvil',
  'mucho',
  'mudar',
  'mudez',
  'mueca',
  'muela',
  'muelo',
  'muera',
  'mugir',
  'mugre',
  'mujer',
  'mular',
  'multa',
  'mundo',
  'muñón',
  'mural',
  'murga',
  'museo',
  'musgo',
  'muslo',
  'mutar',
  'mutis',
  'mutua',
  'mutuo',
  'nácar',
  'nacer',
  'nacho',
  'nadar',
  'nadie',
  'nafta',
  'naipe',
  'nalga',
  'narco',
  'nardo',
  'nariz',
  'narra',
  'nasal',
  'natal',
  'naval',
  'navío',
  'necio',
  'negar',
  'negra',
  'negro',
  'nerón',
  'neura',
  'nevar',
  'nicho',
  'niego',
  'nieto',
  'nieve',
  'nimbo',
  'nimio',
  'ninfa',
  'niñez',
  'nipón',
  'nitro',
  'nivel',
  'níveo',
  'nobel',
  'noble',
  'noche',
  'noema',
  'nogal',
  'nonio',
  'noria',
  'norma',
  'notar',
  'noval',
  'novel',
  'novio',
  'nublo',
  'nuera',
  'nueva',
  'nueve',
  'nuevo',
  'numen',
  'nunca',
  'nutra',
  'oasis',
  'obeso',
  'óbice',
  'óbito',
  'oblea',
  'óbolo',
  'obrar',
  'obvio',
  'ocaso',
  'odeón',
  'odiar',
  'oeste',
  'ohmio',
  'oídio',
  'oidor',
  'ojear',
  'ojera',
  'ojete',
  'ojiva',
  'okapi',
  'olida',
  'oliva',
  'olivo',
  'omaso',
  'omega',
  'omiso',
  'ondeo',
  'ónice',
  'opaco',
  'ópalo',
  'ópera',
  'optar',
  'orden',
  'oreja',
  'orgía',
  'orina',
  'orine',
  'orlar',
  'ornar',
  'oruga',
  'orujo',
  'orzar',
  'osado',
  'óscar',
  'osera',
  'osmio',
  'ostra',
  'otear',
  'otero',
  'otoño',
  'óvalo',
  'oveja',
  'óvido',
  'ovino',
  'óvolo',
  'óvulo',
  'óxido',
  'ozono',
  'pacer',
  'pacto',
  'pádel',
  'padre',
  'pagar',
  'pajar',
  'palco',
  'palia',
  'palma',
  'pampa',
  'panal',
  'panda',
  'pando',
  'panel',
  'panza',
  'pañal',
  'papal',
  'papel',
  'papúa',
  'parar',
  'parca',
  'parco',
  'pardo',
  'pared',
  'pareo',
  'paria',
  'parir',
  'parka',
  'parla',
  'parra',
  'parte',
  'parto',
  'parvo',
  'pasar',
  'paseo',
  'pasmo',
  'pasta',
  'paste',
  'pasto',
  'patán',
  'patas',
  'pateo',
  'páter',
  'patín',
  'patio',
  'pausa',
  'pauta',
  'pauto',
  'pavor',
  'pecar',
  'pecho',
  'pecio',
  'pedal',
  'pedir',
  'pegar',
  'pegue',
  'peina',
  'peine',
  'pelar',
  'pelea',
  'pella',
  'pelón',
  'penal',
  'penar',
  'penca',
  'peñón',
  'peral',
  'perca',
  'perla',
  'perno',
  'perra',
  'perro',
  'persa',
  'pesar',
  'pesca',
  'peste',
  'pezón',
  'piano',
  'picar',
  'picón',
  'picor',
  'pieza',
  'pifia',
  'pilar',
  'pilla',
  'pillo',
  'pilón',
  'pinar',
  'pinta',
  'pinto',
  'pinza',
  'piñón',
  'piojo',
  'pique',
  'pisar',
  'pista',
  'pitar',
  'pitio',
  'pitón',
  'pívot',
  'pizca',
  'pizco',
  'pizza',
  'placa',
  'plaga',
  'plana',
  'plano',
  'plata',
  'plato',
  'plató',
  'plaza',
  'plazo',
  'plebe',
  'plena',
  'pleno',
  'plexo',
  'plomo',
  'pluma',
  'pobre',
  'pocha',
  'pocho',
  'podar',
  'poder',
  'podio',
  'podón',
  'poema',
  'poeta',
  'póker',
  'polar',
  'polca',
  'polea',
  'polen',
  'polio',
  'polis',
  'pollo',
  'polvo',
  'pómez',
  'pompa',
  'poner',
  'pongo',
  'porno',
  'porra',
  'porro',
  'porta',
  'porte',
  'posar',
  'posta',
  'poste',
  'potra',
  'potro',
  'prado',
  'presa',
  'preso',
  'prima',
  'primo',
  'prior',
  'prisa',
  'probo',
  'prole',
  'prosa',
  'púber',
  'pubis',
  'pudin',
  'pudor',
  'púgil',
  'pugna',
  'pujar',
  'pulga',
  'pulir',
  'pulla',
  'pulpa',
  'pulpo',
  'pulso',
  'punir',
  'punta',
  'punto',
  'puñal',
  'purga',
  'quark',
  'queda',
  'queja',
  'quema',
  'quemo',
  'queso',
  'quien',
  'quién',
  'quita',
  'quite',
  'quito',
  'quizá',
  'rabia',
  'racha',
  'radar',
  'radio',
  'radón',
  'rafia',
  'raído',
  'rajar',
  'rallo',
  'ramal',
  'ramos',
  'rampa',
  'rango',
  'rapar',
  'rapaz',
  'rapel',
  'rapto',
  'rasar',
  'rasgo',
  'raspa',
  'raspe',
  'ratio',
  'ratón',
  'rauda',
  'raudo',
  'rayar',
  'rayón',
  'razón',
  'recio',
  'recta',
  'recto',
  'redil',
  'regar',
  'regio',
  'regir',
  'regla',
  'rehén',
  'reina',
  'rejón',
  'relax',
  'reloj',
  'remar',
  'renal',
  'renco',
  'renga',
  'rengo',
  'renta',
  'rento',
  'reñir',
  'reojo',
  'resma',
  'resta',
  'resto',
  'retal',
  'retar',
  'retro',
  'reuma',
  'rezar',
  'riada',
  'riego',
  'rifle',
  'rigor',
  'rimar',
  'rímel',
  'rinde',
  'riñón',
  'rioja',
  'risco',
  'ritmo',
  'rival',
  'rizar',
  'robar',
  'roble',
  'robot',
  'rocín',
  'rocío',
  'rodal',
  'rodar',
  'rodea',
  'rodeo',
  'rodio',
  'rogar',
  'roído',
  'rojez',
  'rollo',
  'rombo',
  'ronca',
  'ronce',
  'ronco',
  'ronda',
  'rondó',
  'roque',
  'rosal',
  'rosca',
  'rosco',
  'rotar',
  'rotor',
  'rozar',
  'ruano',
  'rubio',
  'rubor',
  'rucio',
  'rueca',
  'rueda',
  'ruedo',
  'ruego',
  'rugir',
  'ruido',
  'ruina',
  'rumba',
  'rumbo',
  'rumor',
  'rupia',
  'rural',
  'saber',
  'sabio',
  'sable',
  'sabor',
  'sacar',
  'sacio',
  'sacra',
  'sacro',
  'saeta',
  'sagaz',
  'sajar',
  'sajón',
  'salar',
  'salaz',
  'saldo',
  'salio',
  'salir',
  'salmo',
  'salón',
  'salsa',
  'salto',
  'salud',
  'salva',
  'salve',
  'salvo',
  'samba',
  'sanar',
  'santa',
  'santo',
  'saque',
  'sarda',
  'sardo',
  'sargo',
  'sarna',
  'sarro',
  'sarta',
  'satán',
  'satén',
  'sauce',
  'saudí',
  'sauna',
  'savia',
  'sazón',
  'secar',
  'secta',
  'sedal',
  'sedán',
  'sedar',
  'segar',
  'según',
  'sello',
  'selva',
  'semen',
  'senda',
  'senil',
  'señal',
  'señor',
  'sepia',
  'septo',
  'serie',
  'serio',
  'servo',
  'seseo',
  'sesga',
  'sesgo',
  'sexta',
  'sexto',
  'shock',
  'sidra',
  'siega',
  'siena',
  'siete',
  'sifón',
  'sigla',
  'siglo',
  'sigma',
  'signo',
  'silba',
  'silbo',
  'sílex',
  'silla',
  'silva',
  'símil',
  'simio',
  'sirio',
  'siseo',
  'sismo',
  'sitio',
  'sobar',
  'sobra',
  'sobre',
  'socio',
  'sodio',
  'solar',
  'solaz',
  'sóleo',
  'soler',
  'solfa',
  'solio',
  'sonar',
  'sonda',
  'soñar',
  'soplo',
  'sopor',
  'sorbo',
  'sorda',
  'sordo',
  'sorna',
  'suave',
  'subir',
  'sucio',
  'sudar',
  'sudor',
  'sueco',
  'suela',
  'suelo',
  'sueño',
  'suero',
  'suevo',
  'suflé',
  'sufra',
  'suite',
  'suiza',
  'suizo',
  'sumar',
  'sumir',
  'surco',
  'susto',
  'sutil',
  'swing',
  'tabla',
  'tacha',
  'tache',
  'tacón',
  'tacto',
  'tahúr',
  'talar',
  'talco',
  'talio',
  'talla',
  'talle',
  'tallo',
  'talón',
  'talud',
  'tamiz',
  'tanda',
  'tanga',
  'tango',
  'tanto',
  'tañer',
  'tapar',
  'tapir',
  'tarar',
  'tarde',
  'tardo',
  'tarea',
  'tarot',
  'tarro',
  'tarso',
  'tarta',
  'tasar',
  'tasca',
  'tauro',
  'tazón',
  'tebeo',
  'techo',
  'tecla',
  'tedio',
  'teína',
  'tejar',
  'tejer',
  'tejón',
  'telar',
  'telón',
  'temer',
  'temor',
  'tempo',
  'tenaz',
  'tener',
  'tenis',
  'tenor',
  'tenso',
  'tenue',
  'teñir',
  'terco',
  'terma',
  'termo',
  'terna',
  'terno',
  'terso',
  'tesis',
  'tesla',
  'tesón',
  'testa',
  'texto',
  'tiara',
  'tibia',
  'tibio',
  'tieso',
  'tifón',
  'tifus',
  'tigre',
  'tilde',
  'timar',
  'timba',
  'timón',
  'tinta',
  'tinte',
  'tinto',
  'tiple',
  'tique',
  'tirar',
  'tirón',
  'tisis',
  'titán',
  'tizna',
  'tizne',
  'tizón',
  'tocar',
  'tocón',
  'toldo',
  'tolva',
  'tomar',
  'tonal',
  'tonel',
  'tongo',
  'tonto',
  'topar',
  'toque',
  'tórax',
  'tordo',
  'toreo',
  'toril',
  'torio',
  'tormo',
  'torna',
  'torno',
  'torpe',
  'torre',
  'torso',
  'torta',
  'torva',
  'torvo',
  'tosca',
  'tosco',
  'toser',
  'total',
  'tótem',
  'traba',
  'traca',
  'trace',
  'traer',
  'trago',
  'traje',
  'trama',
  'tramo',
  'trapo',
  'trata',
  'trato',
  'traza',
  'trazo',
  'trece',
  'treta',
  'tribu',
  'trigo',
  'trino',
  'tripa',
  'tripe',
  'triza',
  'troco',
  'trole',
  'trona',
  'trono',
  'tropa',
  'trote',
  'trova',
  'trovo',
  'trozo',
  'truco',
  'trufa',
  'tucán',
  'tueco',
  'tulio',
  'tumba',
  'tumbo',
  'tumor',
  'tunda',
  'túnel',
  'tupir',
  'turba',
  'turbo',
  'turca',
  'turco',
  'turno',
  'tuteo',
  'tutor',
  'twist',
  'ufano',
  'ujier',
  'ultra',
  'umbra',
  'umbro',
  'uncir',
  'ungir',
  'único',
  'unión',
  'untar',
  'uñate',
  'uñero',
  'urdir',
  'urgir',
  'úrico',
  'usado',
  'usted',
  'usual',
  'usura',
  'útero',
  'vacar',
  'vacío',
  'vacuo',
  'vadeo',
  'vagar',
  'vagón',
  'vaina',
  'valer',
  'valía',
  'valla',
  'valle',
  'valón',
  'valor',
  'vapor',
  'varar',
  'vario',
  'variz',
  'varón',
  'vasar',
  'vasco',
  'vasto',
  'váter',
  'vatio',
  'vedar',
  'vejar',
  'vejez',
  'velar',
  'vello',
  'velón',
  'veloz',
  'venda',
  'venia',
  'venir',
  'venta',
  'venus',
  'veras',
  'veraz',
  'verbo',
  'verde',
  'verja',
  'vermú',
  'verso',
  'vetar',
  'viaje',
  'vicia',
  'vicio',
  'vieja',
  'viejo',
  'vigía',
  'vigor',
  'villa',
  'viola',
  'viral',
  'virar',
  'virgo',
  'viril',
  'virus',
  'visar',
  'visir',
  'visor',
  'vista',
  'visto',
  'vital',
  'vítor',
  'viuda',
  'viudo',
  'vivaz',
  'vivir',
  'vocal',
  'voceo',
  'vodka',
  'volar',
  'volea',
  'voraz',
  'voseo',
  'votar',
  'vuelo',
  'vulgo',
  'vulva',
  'weber',
  'xenón',
  'yacer',
  'yanta',
  'yarda',
  'yegua',
  'yelmo',
  'yerba',
  'yermo',
  'yerno',
  'yesca',
  'yogui',
  'yogur',
  'yunta',
  'zafar',
  'zafio',
  'zagal',
  'zaino',
  'zanca',
  'zanco',
  'zanja',
  'zapar',
  'zarco',
  'zarpa',
  'zarza',
  'zarzo',
  'zombi',
  'zonal',
  'zorra',
  'zorro',
  'zueco',
  'zumbo',
  'zurda',
  'zurdo',
  'zurra',
  'ñandú',
  'ñoñez',
  'ñoqui',
]

export default answers
